/* /trial-room page — shopper's shortlist. Reuses tryon_widget.js's exact
 * upload (/api/method/upload_file) + poll (raftor_webhq.catalog.tryon.get_tryon_status,
 * fronted here by trial_room.get_trial_room, which catches up every pending
 * row in one call) pattern, just applied to a room with many items instead
 * of one PDP item.
 *
 * Hydrates from window.rfhqTrialRoomInitial (server-rendered get_trial_room()
 * result) so the first paint needs no round trip, then re-renders from the
 * same whitelisted methods on every mutation.
 */

var POLL_INTERVAL_MS = 2000;
var POLL_TIMEOUT_MS = 60000;

var STATUS_LABEL = {
	Shortlisted: 'Shortlisted',
	Processing: 'Processing',
	Ready: 'Ready',
	Failed: 'Failed',
};
var STATUS_PILL_COLOR = {
	Shortlisted: 'darkgrey',
	Processing: 'blue',
	Ready: 'green',
	Failed: 'red',
};

frappe.ready(function () {
	var root = document.getElementById('rfhq-trial-room-items');
	if (!root) return; // feature off, or not this page

	var state = window.rfhqTrialRoomInitial || { room_photo: null, items: [] };
	renderPhotoCard(state);
	renderItems(state);
	maybePoll(state);
	bindAddToCart();

	document.addEventListener('click', function (e) {
		var removeBtn = e.target.closest('[data-rfhq-trial-remove]');
		if (removeBtn) {
			e.preventDefault();
			frappe.call({
				method: 'raftor_webhq.catalog.trial_room.remove_from_trial_room',
				args: { item_code: removeBtn.dataset.rfhqTrialRemove },
				callback: function (r) {
					if (r && r.message) {
						state = r.message;
						renderPhotoCard(state);
						renderItems(state);
						maybePoll(state);
						if (window.rfhqUpdateTrialRoomBadge) window.rfhqUpdateTrialRoomBadge(false);
					}
				},
			});
			return;
		}

		var replaceBtn = e.target.closest('[data-rfhq-trial-replace-photo]');
		if (replaceBtn) {
			var input = document.getElementById('rfhq-trial-room-file-input');
			if (input) input.click();
		}
	});

	document.addEventListener('change', function (e) {
		var input = e.target.closest('#rfhq-trial-room-file-input');
		if (!input) return;
		var file = input.files && input.files[0];
		if (!file) return;
		uploadRoomPhoto(file);
	});
});

/**
 * A shopper who's tried something on and likes it should be able to buy it
 * without leaving the room. Reuses the exact markup contract cart.js's
 * addButton/gotoButton pair already defines (.btn-add-to-cart-list
 * [data-item-code] / .go-to-cart-grid), so webshop's own
 * bind_add_to_cart_action() drives it with no new cart logic here - same
 * "borrow the binder, don't reimplement it" approach grid.js itself uses.
 * Bound once (delegated on .page_content, survives every innerHTML swap
 * below) rather than re-bound per render, which would double-fire clicks.
 * Real namespace is webshop.webshop.shopping_cart (shopping_cart.js line 5) -
 * see the matching fix + comment in grid.js's _afterAppend, same bug.
 */
function bindAddToCart() {
	if (typeof webshop === 'undefined') return;
	var cart = webshop.webshop && webshop.webshop.shopping_cart && webshop.webshop.shopping_cart.bind_add_to_cart_action;
	if (cart && !bindAddToCart._bound) {
		webshop.webshop.shopping_cart.bind_add_to_cart_action();
		bindAddToCart._bound = true;
	}
}

function uploadRoomPhoto(file) {
	var photoCard = document.getElementById('rfhq-trial-room-photo');
	if (photoCard) photoCard.querySelector('.rfhq-trial-room-photo-status').textContent = __('Uploading photo...');

	var formData = new FormData();
	formData.append('file', file);
	formData.append('is_private', 1);

	fetch('/api/method/upload_file', {
		method: 'POST',
		headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
		body: formData,
	})
		.then(function (res) { return res.json(); })
		.then(function (data) {
			var fileUrl = data && data.message && data.message.file_url;
			if (!fileUrl) throw new Error('upload failed');
			if (photoCard) photoCard.querySelector('.rfhq-trial-room-photo-status').textContent = __('Processing your shortlist...');
			return frappe.call({
				method: 'raftor_webhq.catalog.trial_room.set_room_photo',
				args: { file_url: fileUrl },
			});
		})
		.then(function (r) {
			var state = r && r.message;
			if (!state) throw new Error('no response');
			renderPhotoCard(state);
			renderItems(state);
			maybePoll(state);
		})
		.catch(function () {
			if (photoCard) photoCard.querySelector('.rfhq-trial-room-photo-status').textContent = __('Something went wrong. Please try again.');
		});
}

function renderPhotoCard(state) {
	var card = document.getElementById('rfhq-trial-room-photo');
	if (!card) return;

	if (state.room_photo) {
		card.innerHTML =
			'<div class="rfhq-trial-room-photo-row">' +
				'<img src="' + escapeAttr(state.room_photo) + '" alt="' + __('Your photo') + '" class="rfhq-trial-room-photo-thumb">' +
				'<div>' +
					'<p class="rfhq-order-panel-label">' + __('Your Photo') + '</p>' +
					'<button type="button" class="rfhq-cta-secondary rfhq-trial-room-photo-btn" data-rfhq-trial-replace-photo>' + __('Replace Photo') + '</button>' +
				'</div>' +
			'</div>' +
			'<input type="file" accept="image/*" capture="user" id="rfhq-trial-room-file-input" class="rfhq-trial-room-file-input">' +
			'<div class="rfhq-trial-room-photo-status"></div>';
	} else {
		card.innerHTML =
			'<p class="rfhq-order-panel-label">' + __('Upload Your Photo') + '</p>' +
			'<p class="rfhq-trial-room-photo-hint">' + __('One photo is used for every item you try on in this room.') + '</p>' +
			'<button type="button" class="rfhq-cta-primary rfhq-trial-room-photo-btn" data-rfhq-trial-replace-photo>' + __('Upload Photo') + '</button>' +
			'<input type="file" accept="image/*" capture="user" id="rfhq-trial-room-file-input" class="rfhq-trial-room-file-input">' +
			'<div class="rfhq-trial-room-photo-status"></div>';
	}
}

function renderItems(state) {
	var root = document.getElementById('rfhq-trial-room-items');
	if (!root) return;

	if (!state.items || !state.items.length) {
		root.innerHTML = '<div class="rfhq-order-card"><p class="rfhq-trial-room-empty">' +
			__('Nothing shortlisted yet. Browse products and tap "Try In Trial Room" to add one.') +
			'</p></div>';
		return;
	}

	root.innerHTML = state.items.map(renderItemCard).join('');
}

function renderItemCard(item) {
	var pillColor = STATUS_PILL_COLOR[item.status] || 'darkgrey';
	var pillLabel = STATUS_LABEL[item.status] || item.status;

	var media = item.status === 'Ready' && item.result_image
		? '<img src="' + escapeAttr(item.result_image) + '" alt="' + escapeAttr(item.item_name || item.item_code) + '" class="rfhq-trial-card-image">'
		: '<img src="' + escapeAttr(item.image || '') + '" alt="' + escapeAttr(item.item_name || item.item_code) + '" class="rfhq-trial-card-image rfhq-trial-card-image--source">';

	var score = '';
	if (item.status === 'Ready' && item.recommendation_score != null) {
		score =
			'<div class="rfhq-trial-score">' +
				'<div class="rfhq-trial-score-bar"><div class="rfhq-trial-score-fill" style="width:' + item.recommendation_score + '%"></div></div>' +
				'<span class="rfhq-trial-score-label">' + item.recommendation_score + '% &middot; ' + escapeHtml(item.recommendation_label || '') + '</span>' +
			'</div>';
	} else if (item.status === 'Failed') {
		score = '<p class="rfhq-trial-card-error">' + escapeHtml(item.error_message || __('Try-on could not be completed.')) + '</p>';
	}

	// item_code here is the template/parent code (e.g. "JP-001"), not a
	// specific size - core's update_cart throws "Template Item Selected"
	// if you try to add that directly (found live testing this). A
	// template item's real Add to Cart lives on its PDP, where the size
	// picker already resolves it to a sellable variant code - so a
	// has_variants item gets a link there instead of a button that would
	// just error. Same .btn-add-to-cart-list / .go-to-cart-grid pair
	// cart.js's addButton()/gotoButton() render for non-variant items, so
	// webshop's own binder (bound once, see bindAddToCart) drives both
	// halves without any cart logic of ours.
	var cartAction = item.has_variants
		? (item.route
			? '<a href="/' + escapeAttr(item.route) + '" class="btn btn-sm btn-outline-primary rfhq-trial-cart-btn">' + __('Select Size') + '</a>'
			: '')
		: '<div class="rfhq-trial-cart-action">' +
				'<div class="btn btn-sm btn-primary btn-add-to-cart-list rfhq-trial-cart-btn" data-item-code="' + escapeAttr(item.item_code) + '">' + __('Add to Cart') + '</div>' +
				'<a href="/cart"><div class="btn btn-sm btn-primary btn-add-to-cart-list go-to-cart-grid hidden rfhq-trial-cart-btn" data-item-code="' + escapeAttr(item.item_code) + '">' + __('Go to Cart') + '</div></a>' +
			'</div>';

	return (
		'<div class="rfhq-card rfhq-trial-card" data-item-code="' + escapeAttr(item.item_code) + '">' +
			'<div class="rfhq-trial-card-media-wrap">' + media + '</div>' +
			'<div class="rfhq-trial-card-body">' +
				'<div class="rfhq-trial-card-head">' +
					'<span class="rfhq-trial-card-name">' + escapeHtml(item.item_name || item.item_code) + '</span>' +
					'<span class="rfhq-order-pill rfhq-order-pill--' + pillColor + '">' + escapeHtml(pillLabel) + '</span>' +
				'</div>' +
				score +
				cartAction +
				'<div class="rfhq-trial-card-actions">' +
					(item.route ? '<a href="/' + escapeAttr(item.route) + '" class="rfhq-trial-card-link">' + __('View Product') + '</a>' : '') +
					'<button type="button" class="rfhq-trial-card-remove" data-rfhq-trial-remove="' + escapeAttr(item.item_code) + '">' + __('Remove') + '</button>' +
				'</div>' +
			'</div>' +
		'</div>'
	);
}

function maybePoll(state, startedAt) {
	var hasProcessing = (state.items || []).some(function (i) { return i.status === 'Processing'; });
	if (!hasProcessing) return;

	startedAt = startedAt || Date.now();
	if (Date.now() - startedAt > POLL_TIMEOUT_MS) return;

	setTimeout(function () {
		frappe.call({
			method: 'raftor_webhq.catalog.trial_room.get_trial_room',
			callback: function (r) {
				var next = r && r.message;
				if (!next) return;
				renderItems(next);
				maybePoll(next, startedAt);
			},
		});
	}, POLL_INTERVAL_MS);
}

function escapeHtml(value) {
	return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
		return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
	});
}

function escapeAttr(value) {
	return escapeHtml(value);
}
